import React, { useState, useEffect } from 'react';

// Simulated paid policy data
const mockPaidPolicies = [
  {
    id: 101,
    title: 'Clinical Governance Framework',
    category: 'Governance',
    description: 'Comprehensive framework for clinical governance implementation.',
    price: '$49',
    downloads: 42,
  },
  {
    id: 102,
    title: 'Digital Health Strategy',
    category: 'Technology',
    description: 'Strategic roadmap for digital transformation in healthcare.',
    price: '$59',
    downloads: 31,
  },
  // Add more mock policies as needed
];

export default function PaidPolicyComponent() {
  const [policies, setPolicies] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setPolicies(mockPaidPolicies);
    setFiltered(mockPaidPolicies);
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearch(term);
    setFiltered(
      policies.filter(
        (p) =>
          p.title.toLowerCase().includes(term) ||
          p.category.toLowerCase().includes(term)
      )
    );
  };

  const handleDownload = (policy) => {
    setSelectedPolicy(policy);
    setShowForm(true);
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-4">Paid Policies</h1>
      <p className="mb-6 text-gray-700">
        Explore IPSA’s premium policy documents. Registration, verification, personalization, and payment are required before download.
      </p>

      <input
        type="text"
        placeholder="Search by title or category"
        value={search}
        onChange={handleSearch}
        className="mb-6 w-full p-2 border rounded"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {filtered.map((policy) => (
          <div key={policy.id} className="border p-4 rounded shadow">
            <h2 className="text-xl font-semibold">{policy.title}</h2>
            <p className="text-sm text-gray-600">{policy.category}</p>
            <p className="mt-2">{policy.description}</p>
            <p className="text-xs text-gray-500 mt-1">
              Downloads: {policy.downloads}
            </p>
            <p className="text-md font-bold mt-2">Price: {policy.price}</p>
            <button
              onClick={() => handleDownload(policy)}
              className="mt-4 bg-purple-600 text-white px-4 py-2 rounded"
            >
              Personalize & Purchase
            </button>
          </div>
        ))}
      </div>

      {showForm && selectedPolicy && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg max-w-md w-full">
            <h3 className="text-xl font-bold mb-4">
              Personalize & Purchase: {selectedPolicy.title}
            </h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert('Redirecting to payment gateway...');
                setShowForm(false);
              }}
            >
              <label className="block mb-2">
                Institution Name:
                <input type="text" required className="w-full p-2 border rounded" />
              </label>
              <label className="block mb-2">
                Contact Email:
                <input type="email" required className="w-full p-2 border rounded" />
              </label>
              <label className="block mb-4">
                Intended Use:
                <textarea required className="w-full p-2 border rounded" />
              </label>
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded"
                >
                  Proceed to Payment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
